import { Colors } from '../consts/Colors';
import { Scales } from '../consts/Scales';

export default class RoundedContainer extends Phaser.GameObjects.Container {
    constructor(scene, x, y, width, height, iconKey, text, borderColor) {
        super(scene, x, y, []);
        this.scene = scene;
        scene.add.existing(this);

        // Background
        this.bg = this.scene.add.graphics();
        this.bg.fillStyle(0x000000, 0);
        this.bg.lineStyle(2, borderColor, 1);
        this.bg.fillRoundedRect(-width / 2, -height / 2, width, height, 80);
        this.bg.strokeRoundedRect(-width / 2, -height / 2, width, height, 80);
        this.add(this.bg);

        // Icon
        this.icon = this.scene.add
            .image(
                this.scene.game.data.langue === 'ara' ? width / 2 - 40 : -width / 2 + 60,
                0,
                iconKey,
            )
            .setOrigin(0.5)
            .setScale(1);
        this.add(this.icon);

        // Text
        this.textObj = this.scene.add
            .text(this.scene.game.data.langue === 'ara' ? 150 : -width / 2 + 110, 0, text, {
                fontSize: `${24 * Scales.scaleX}px`,
                fontFamily:
                    'DMSansRegular, "NotoSansJP", "NotoSansArabic", "NotoSansThai", sans-serif',
                fill: '#ffffff',
                wordWrap: { width: width - 105 },
                align: this.scene.game.data.langue === 'ara' ? 'right' : 'left',
                padding: { bottom: 10, top: 10 },
                rtl: this.scene.game.data.langue === 'ara',
            })
            .setOrigin(this.scene.game.data.langue === 'ara' ? 1 : 0, 0.5);
        this.add(this.textObj);
    }
}
